import { Headphones, Layers, Magnet, Minimize2, Settings2, Infinity, Building2 } from "lucide-react";
import { WHY_TRACKSY, POLICIES } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { SectionHeader, PrimaryButton, SecondaryButton } from "@/components/Primitives";

const ICONS = { range: Infinity, compact: Minimize2, magnetic: Magnet, setup: Settings2, uses: Layers, business: Building2, support: Headphones };

export const WhyTracksy = () => (
  <section id="why-tracksy" data-testid="why-tracksy-section" className="px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
    <div className="mx-auto max-w-7xl">
      <SectionHeader eyebrow="Why Tracksy?" title="Unlimited range. Zero subscriptions. Magnetic by design." desc="The sharpest tracker in your pocket — built for cars, trailers, tools and anything you can't afford to lose." className="mb-12" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {WHY_TRACKSY.map((w, i) => {
          const Icon = ICONS[w.id];
          return (
            <Reveal key={w.id} delay={i * 0.05} className={i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}>
              <div data-testid={`why-card-${w.id}`} className="h-full rounded-[1.5rem] border border-black/5 bg-white p-6 shadow-subtle transition-shadow duration-300 hover:shadow-lift">
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-tracksy-orange/10">
                  <Icon className="h-5 w-5 text-tracksy-orange" />
                </span>
                <h3 className="mt-5 font-heading text-base font-bold text-tracksy-ink">{w.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-tracksy-sub">{w.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export const Policies = () => (
  <section id="policies" data-testid="policies-section" className="scroll-mt-24 px-4 py-10 sm:px-6 lg:px-8">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-4 md:grid-cols-3">
      {POLICIES.map((p, i) => (
        <Reveal key={p.id} delay={i * 0.06}>
          <div data-testid={`policy-${p.id}`} className="rounded-[1.5rem] border border-black/5 bg-tracksy-cream p-6">
            <p className="text-xs font-bold uppercase tracking-widest text-tracksy-orange">{p.title}</p>
            <p className="mt-2 text-sm leading-relaxed text-tracksy-ink">{p.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
    <Reveal>
      <div className="mx-auto max-w-7xl rounded-[2.5rem] bg-tracksy-ink px-6 py-16 text-center shadow-lift sm:px-10 lg:py-20">
        <p className="text-xs font-bold uppercase tracking-widest text-tracksy-orange">Tracksy</p>
        <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-white sm:text-5xl">Ready to Track What Matters?</h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-white/70 sm:text-lg">
          Add another layer of visibility to the vehicles, equipment and essentials you own.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <PrimaryButton to="/shop" testId="final-cta-shop">Shop Tracksy</PrimaryButton>
          <SecondaryButton to="/fleet" dark testId="final-cta-fleet">Explore Tracksy Fleet</SecondaryButton>
        </div>
      </div>
    </Reveal>
  </section>
);
